import { RoundedModal } from "@/components/modal/rounded-modal";
import { FilledButton, OutlinedButton } from "@/components/ui/buttons";
import { cn } from "@/utils/cn";
import { textVariants } from "@/utils/text-variants";
import { memo } from "react";

interface RemoveMealConfirmModalProps {
  isOpen: boolean;
  onConfirm: () => void;
  onCancel: () => void;
  isRemoving?: boolean;
}

export const RemoveMealConfirmModal = memo(function RemoveMealConfirmModal({
  isOpen,
  onConfirm,
  onCancel,
  isRemoving = false,
}: RemoveMealConfirmModalProps) {
  return (
    <RoundedModal isOpen={isOpen} onDidDismiss={onCancel} backdropDismiss={true}>
      <div className="flex flex-col items-center gap-2.5 rounded-3xl bg-white px-3.5 py-3.5">
        <div className="space-y-2.5 px-2 pt-2 pb-6">
          <h2 className={cn(textVariants.title3, "text-center")}>Remove Meal</h2>

          <p className={cn(textVariants.body, "text-center")}>
            Are you sure you want to remove this meal?
          </p>
        </div>

        <div className="w-full space-y-3">
          <FilledButton
            color="black"
            onClick={onConfirm}
            disabled={isRemoving}
            className="w-full uppercase"
            style={{ backgroundColor: "#DC2626" }}
          >
            {isRemoving ? "Removing..." : "Remove"}
          </FilledButton>

          <OutlinedButton
            onClick={onCancel}
            color="gray"
            disabled={isRemoving}
            className="w-full uppercase"
          >
            Cancel
          </OutlinedButton>
        </div>
      </div>
    </RoundedModal>
  );
});
